import {Navigate, useLocation} from "react-router-dom";

import {Register} from "@/pages/auth/register.tsx";

import {useAuth} from "@/lib/auth";

export const RegisterRoute = () => {
  const {token, loading} = useAuth();
  const loc = useLocation();

  if (loading) return null;
  if (token) {
    const to = new URLSearchParams(loc.search).get("to") || "/servers";
    return <Navigate to={to} replace />;
  }

  return <Register />;
};
